import { ApiPath } from 'enums';
import { Get, Post } from 'utils';

export const login = async ({ username, password }) => {
  const res = await Post(`${ApiPath.Login}`, { username, password });
  return res.data;
};

export const logout = async () => {
  const res = await Get(`${ApiPath.Logout}`);
  return res.data;
};
